import { useEffect } from 'react';

/**
 * Cierra modales/drawers al pulsar Escape · accesibilidad WCAG 2.1
 * Si modal_visible es false no se registra el listener.
 */
export function useEscape(onClose: () => void, enabled = true): void {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [enabled, onClose]);
}
